// import {StyledH4} from '@app/Styled/index';
import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
// import {useTranslation} from 'react-i18next';
import {MainLoader, ReportComments} from '@components';
import {sagaActions} from './redux/saga';

const CommentsHistory = ({isActive, report}) => {
  const [isLoaded, setLoaded] = useState(false);
  const dispatch = useDispatch();
  const comments = useSelector((state) => state.validators.comments);
  // const [t] = useTranslation();

  useEffect(() => {
    if (isActive && !isLoaded) {
      setLoaded(true);
    }
  }, [isActive, isLoaded]);

  useEffect(() => {
    if (isLoaded && comments.reportId !== report.id) {
      dispatch({
        type: sagaActions.FETCH_REPORT_COMMENTS,
        payload: {reportId: report.id, values: {page: 1, pageSize: 100}}, // TODO: add infinite loader here to load next comments
      });
    }
  }, [isLoaded, report]);

  const renderComments = () => {
    return <ReportComments data={comments.data} loading={comments.loading} />;
  };

  return isLoaded ? (
    <div>
      {/* <StyledH4 className="mb-3">
        {t('owner.validators.reports.comments.pageHeading')}
      </StyledH4> */}
      {comments.loading ? (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      ) : null}
      {renderComments()}
    </div>
  ) : null;
};

export default CommentsHistory;
